import styled, { css, keyframes } from 'styled-components';
import { InputTag } from 'components/Input/styles';
import Button from 'components/Button';
import {
  border1,
  boxShadow1,
  whitesmoke,
} from '../../../../utils/style/colors';

export const RolesContainer = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
  gap: 10px;
`;

export const RolesForm = styled('form')`
  flex: none;
  display: flex;
  flex-direction: column;
`;

export const RolesFormTitle = styled('div')`
  color: #90a4ae;
  font-size: 14px;
  margin-bottom: 10px;
`;

export const RoleInputContainer = styled('div')`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  justify-content: space-between;
`;

export const RoleInputRow = styled('div')`
  display: flex;
  align-items: stretch;
  flex-direction: row;
  justify-content: space-between;
`;

export const AddRoleButton = styled(Button)`
  & > span {
    justify-content: center;
  }
`;

export const StyledInput = InputTag.withComponent('input');

const fadeItem = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const animationRule = css`
  ${fadeItem} cubic-bezier(0.075, 0.82, 0.165, 1) 0.5s;
`;

export const RolesListContainer = styled('ul')`
  border: ${border1};
  overflow: scroll;
  border-radius: 15px;
  display: flex;
  overflow: auto;
  overflow: overlay;
  margin: 0px;
  height: 100%;
  box-shadow: ${boxShadow1};
  flex-direction: column;
  & > li {
    flex: none;
    display: block;
    padding: 10px 10px 10px 20px;
    position: relative;
    animation: ${animationRule};
    background: ${whitesmoke};
    min-height: fit-content;
    align-items: center;
    border-bottom: 1px solid #dcdcdc;
  }
`;

export const RoleDescription = styled('div')`
  color: #90a4ae;
  font-size: 12px;
  font-weight: 400;
`;

export const RoleName = styled('div')`
  display: flex;
  width: 100%;
  justify-content: space-between;
  font-weight: 400;
`;

export const Role = styled('div')`
  flex-grow: 1;
`;

export const Card = styled('div')`
  flex: 0.5;
  height: fit-content;
  margin: 1em;
  display: flex;
  background: var(--exact-white);
  box-shadow: 0 3px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px;
  @media only screen and (max-width: 769px) {
    flex: none;
  }
`;
